module.exports = __webpack_public_path__ + "static/media/Map.51fa7ac9.jpg";